import * as actionTypes from "./actionTypes";
import axios from "axios";

export const initGetChat = () => {
    return {
        type: actionTypes.INIT_GET_CHAT,
        chatLoading: true
    }
};

export const successGetChat = (data) => {
    return {
        type: actionTypes.SUCCESS_GET_CHAT,
        chatLoading: false,
        chat: data.data
    }
};

export const failGetChat = (error) => {
    return {
        type: actionTypes.FAIL_GET_CHAT,
        chatLoading: false,
        error: error

    }
};

export const getChat = (bearerToken, chatId, receiverId, senderId, sendMessage) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    };

    return dispatch => {
        if (!sendMessage) {
            dispatch(initGetChat())
        }
        axios.get(`chats/${chatId}`, config)
            .then(response => {
                dispatch(successGetChat(response.data))
                const idsArray = [];
                response.data.data.chat_messages.map(mess => idsArray.push(mess.id))
                const setAsReadData = {
                    ids: idsArray
                };
                axios.post('chat_messages/set_as_read', setAsReadData, config)
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error.message)
                    })
            })
            .catch(error => {
                console.log(error)
                dispatch(failGetChat(error.message))
            })

    }
};


//############################################################## clean Chat:

export const cleanChat = () => {
    return {
        type: actionTypes.CLEAN_CHAT,
        chat: null
    }
};

// #################################################### Create Message :

export const initCreateMessage = () => {
    return {
        type: actionTypes.INIT_CREATE_MESSAGE,
        sending: true
    }
};

export const successCreateMessage = () => {
    return {
        type: actionTypes.INIT_CREATE_MESSAGE,
        sending: false,

    }
};

export const failCreateMessage = () => {
    return {
        type: actionTypes.INIT_CREATE_MESSAGE,
        sending: false,

    }
};

export const createMessage = (bearerToken, message, receiverId, senderId, chatId, recvierToken) => {
    // fcm CONFIG AND DATA :
    const configFcm = {
        headers: {
            Authorization: "key=AAAAhGYJ0_A:APA91bHf-5EcBMiPOZazfcyROFlPsTioYRVTlmoYEdhjUOGFOpJ8g0fXWb_dezzlHMyoM1Vo_dm7z5sYZto_9BJOp7tryk7vIrZjGentgKiLAzyBz3SecdWHWr6MykeMlPYBQUXW49Rr",
            "Content-Type": "application/json"
        }
    };
    const dataFcm = {
        to: recvierToken,
        notification: {
            title: 'New message',
            body: message,
        }
    }
    // pcariAPI CONFIG AND DATA
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    };

    const data = {
        message: message,
        receiver_id: receiverId
    };

    return dispatch => {
        axios.post('chat_messages', data, config)
            .then(response => {
                dispatch(getChat(bearerToken, chatId, receiverId, senderId, true));
                //
                axios.post('https://fcm.googleapis.com/fcm/send', dataFcm, configFcm).then(function (response) {
                    console.log(response, '\n##########################');
                }).catch(function (error) {
                    console.error(error);
                })
                //
            })
            .catch(error => {
                console.log(error.message)
            })
    }
};